import type { FormItem } from 'types';
import type { ModulesAndAgendasState } from '../index';
import { findItemIndex, recalcSectionItems } from 'utils/section/items.ts';
import { findTabIndex } from 'utils/section/tabSection.ts';

interface Payload {
  visibilities: FormItem['visibilities'];
  sectionId: string;
  itemId: string;
  isAuxiliary?: boolean;
  currentTab: number;
  currentSubTab: number;
}

export const updateSectionItemVisibilities = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { visibilities, sectionId, itemId, isAuxiliary, currentTab, currentSubTab } = payload;

  const tabSections = state.tabSections;

  const currentTabIndex = findTabIndex(state.tabSections, currentTab);
  if (currentTabIndex === -1) throw new Error('Invalid tab index');

  const sectionIndex = tabSections[currentTabIndex].sections.findIndex((section) => section.id === sectionId);
  if (sectionIndex === -1) throw new Error('Invalid section index');

  const section = tabSections[currentTabIndex].sections[sectionIndex];

  const subTabs = section.formItemTabs || [];
  const subTabIndex = findTabIndex(subTabs, currentSubTab);
  if (subTabIndex === -1) throw new Error('Invalid sub tab index');

  const subTabItems = subTabs[subTabIndex].items || [];
  const subTabItemIndex = findItemIndex(subTabItems, itemId);
  if (subTabItemIndex === -1) throw new Error('Invalid sub tab item index');

  const subTabItem = section.formItemTabs[subTabIndex].items[subTabItemIndex];
  if (!subTabItem?.data) return state;

  section.formItemTabs[subTabIndex].items[subTabItemIndex].data = {
    ...subTabItem.data,
    visibilities,
    isAuxiliary: isAuxiliary ?? false,
  };

  section.items = recalcSectionItems(section.formItemTabs);
};
